import Axios from '../utils/axios-utils';


// user sign up
export const createUser = async (data) => {
    try {
        const response = await Axios.post('/auth/signup', {
            firstName: data.firstName,
            lastName: data.lastName,
            // username: data.username,
            email: data.email,
            password: data.password,
            msisdn: data.msisdn,
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Registration error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Registration failed" }
        };
    }
};

// user login
export const loginUser = async (data) => {
    try {
        const response = await Axios.post('/auth/login', {
            email: data.email,
            password: data.password
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Login error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "An error occurred during login" }
        };
    }
};

// verify email otp
export const verifyEmailOTP = async (data) => {
    try {
        const response = await Axios.post('/otp/verify', {
            code: data.code,
            verificationKey: data.verificationKey
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Verify user OTP Error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "OTP Verification failed" }
        };
    }
};

// verify password otp
export const verifyPasswordOTP = async (data) => {
    try {
        const response = await Axios.post('/otp/verify', {
            code: data.code,
            verificationKey: data.verificationKey,
            password: data.newPassword,
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Verify user OTP Error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "OTP Verification failed" }
        };
    }
};

// resend otp
export const resendOTP = async (email, context) => {
    try {
        const response = await Axios.post('/otp', {
            email,
            context
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.log("resend user OTP Error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "OTP Resend failed" }
        };
    }
};

// get bussiness accounts
export const getAccounts = async (token) => {
    try {
        const response = await Axios.get('/accounts', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Get user error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Failed to fetch user profile" }
        };
    }
};

// create bussines account
export const createAccounts = async (payload, token) => {
    try {
        const response = await Axios.post('/accounts', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return {
            success: response.data.status === 'success',
            data: response.data
        };
    } catch (error) {
        console.log("Create account error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Failed to create account" }
        };
    }
};

// update account 
export const updateAccount = async (accountId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Account error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Account failed" }
        };
    }
};

// check auth status
export const getAuthStatus = async (token) => {
    try {
        const response = await Axios.get('/auth/status', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Check Auth Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Failed to Check Auth Status" }
        };
    }
};